export default __webpack_public_path__ + "static/media/sibling-rivalry@2x 5.f82214e4.png";